<template>
  <!--   -->
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleOk" 
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :ok-disabled="disableSubmit"
    :cancelText="language['common.closeButton']"
    >
    <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery" >
        <a-row :gutter="24">
          <a-col  :sm="8">
            <a-form-item :label="language['application.applicationName']">
              <a-input placeholder="" v-model="queryParam.applicationName" allowClear style="width: 100%;"></a-input>
            </a-form-item>
          </a-col>

          <a-col  :sm="8">
            <a-form-item :label="language['column.status']">
              <j-dict-select-tag placeholder="" v-model="queryParam.applicationStatus"  dictCode="application_status" allowClear />
            </a-form-item>
          </a-col>

          <a-col  :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <!-- <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->


    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已選擇 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>項
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="applicationImgPath" slot-scope="text, record, index">
              <div class="anty-img-wrap">
                <a-avatar shape="square" :src="getAvatarView(record.applicationImgPath)" icon="user"/>
              </div>
        </template>
      </a-table>
    </div>

  </a-card>
    <!-- <div style="text-align: center;margin-top: 20px">
      <a-button @click="handleOk" type="primary" style="margin: 0px 10px" >確定</a-button>
      <a-button @click="handleCancel" style="margin: 0px 10px">取消</a-button>
    </div> -->
  </j-modal>

  
</template>

<script>

  
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {getAction,postAction,getFileAccessHttpUrl} from '@/api/manage'



  export default {
    name: 'AppModal',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      
    },
    data () {
      const { language } = this.$store.getters;
      return {
        model: {},
        title:'应用列表',
        width:1000,
        visible: false,
        disableSubmit: true,
        disableMixinCreated:false,//控制第一次打开弹框 是否查询
        url: {
          list: "/sys/sysBmApplication/listForEmp",
        },
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title:language['application.applicationCode'],
            align:"center",
            dataIndex: 'applicationCode',
            customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
          },
          {
            title:language['application.applicationName'],
            align:"center",
            dataIndex: 'applicationName',
            customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
          },
          {
            title:language['application.applicationImgPath'],
            align:"center",
            dataIndex: 'applicationImgPath',
            scopedSlots: {customRender: "applicationImgPath"},
          },
          {
            title:language['emp.develop.appType'],
            align:"center",
            dataIndex: 'appType',
            customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
          },
          {
            title:language['application.applicationStatus'],
            align:"center",
            dataIndex: 'applicationStatusDictText',
            customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
          },


        ],
        colId:null,
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    created(){
      this.searchReset()
    },
    methods: {
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,'platform')
      },

      searchQuery() {//搜索查询
        this.loadData(1);
      },
      searchReset(colId) {//重置
        this.colId = colId
        this.queryParam = {}
        this.loadData(1)
        // this.dataSource =[]
      },
      onSelectChange(selectedRowKeys, selectionRows) {//监听 单选框是否选中  选中多选框 触发 封装数据
        this.selectedRowKeys = selectedRowKeys
        this.selectionRows = selectionRows;
        if(this.selectedRowKeys.length>0){
           this.disableSubmit=false
        }else{
           this.disableSubmit= true
        }
        
     },

      
      async handleOk () {
        let idList = this.selectedRowKeys
        if(this.selectedRowKeys.length>0){
           await postAction('/sys/sysBmApplication/addAppToTemplate7?colId='+this.colId,idList).then(res=>{
              if(res.success){
                this.$message.success(res.message)
                this.$emit('clickOK')
              }
           })
        }
        this.handleCancel()
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
    }
  }
</script>

<style scoped>
 

</style>